import React, { useEffect, useState } from 'react'
import { Button, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap'
import McDataServices from '../../services/McDataServices'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { RSelect } from '../../components/Component'

const AssignMailingPackageModal = ({ isOpen, toggle, selectedUser }) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [options, setOptions] = useState([])
  const [selectedPackage, setSelectedPackage] = useState(null)

  useEffect(() => {
    if (isOpen) {
      setSelectedPackage(null)
      fetchPackages()
    }
  }, [isOpen])

  const fetchPackages = async () => {
    setLoading(true)
    try {
      const response = await McDataServices.getB2bPackages()
      let newOptions = []
      if (response && !Array.isArray(response) && typeof response === 'object') {
        newOptions = Object.entries(response).map(([id, name]) => ({ value: id, label: name }))
      } else if (Array.isArray(response)) {
        newOptions = response.map(pkg => ({
          value: pkg.id,
          label: pkg.name
        }))
      }
      setOptions(newOptions)
    } catch (error) {
      toast.error(t('generic_error_text', 'Failed to fetch packages'), {
        position: 'top-right',
        autoClose: 3000
      })
    } finally {
      setLoading(false)
    }
  }

  const handleSave = async () => {
    if (!selectedPackage || !selectedUser) return
    setSaving(true)

    try {
      const payload = {
        userId: selectedUser.id,
        b2bPackageId: selectedPackage.value
      }

      await McDataServices.assignMailingPackage(payload)
      toast.success(t('admin.modal.assignSuccess', 'Package assigned successfully.'), {
        position: 'top-right',
        autoClose: 3000
      })
      toggle()
    } catch (error) {
      console.error('Assign mailing package failed', error)
      toast.error(t('admin.modal.assignError', 'Failed to assign package.'), {
        position: 'top-right',
        autoClose: 3000
      })
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-dialog-centered">
      <ModalHeader toggle={toggle} close={<button className="close" onClick={toggle}>×</button>}>
        {t('admin.table.assignMailingPackage', 'Assign Mailing Package')}
      </ModalHeader>
      <ModalBody>
        <p>
          {t('admin.table.assignMailingPackageDesc', 'Select a mailing package to assign to:')}{' '}
          <strong>{selectedUser?.email || selectedUser?.userName}</strong>
        </p>
        <FormGroup>
          <Label>{t('admin.modal.packageName', 'Package Name')}</Label>
          <RSelect
            options={options}
            value={selectedPackage}
            onChange={(selected) => setSelectedPackage(selected)}
            placeholder={loading ? t('admin.loading', 'Loading...') : t('sp_select', 'Select...')}
            isDisabled={loading}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle}>
          {t('admin.modal.cancel', 'Cancel')}
        </Button>
        <Button color="primary" onClick={handleSave} disabled={!selectedPackage || saving}>
          {saving ? <Spinner size="sm"/> : t('admin.modal.saveChanges', 'Save Changes')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AssignMailingPackageModal
